module.exports = __webpack_public_path__ + "static/media/Simple-portfolio.df1f74bb.png";